import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

export interface ForceUpdateState {
  active: boolean;
  message: string;
  storeUrl: string | null;
  iosStoreUrl: string | null;
  androidStoreUrl: string | null;
}

interface ForceUpdatePayload {
  message?: unknown;
  storeUrl?: unknown;
  iosStoreUrl?: unknown;
  androidStoreUrl?: unknown;
  force_update?: unknown;
  forceUpdate?: unknown;
  code?: unknown;
}

@Injectable({ providedIn: 'root' })
export class ForceUpdateStateService {
  private readonly _state = signal<ForceUpdateState>({
    active: false,
    message: 'アプリのアップデートが必要です。アップデートしてください。',
    storeUrl: null,
    iosStoreUrl: null,
    androidStoreUrl: null,
  });

  get state() {
    return this._state.asReadonly();
  }

  set(state: Partial<ForceUpdateState>): void {
    this._state.update((prev) => ({ ...prev, ...state }));
  }

  clear(): void {
    this._state.set({
      active: false,
      message: 'アプリのアップデートが必要です。アップデートしてください。',
      storeUrl: null,
      iosStoreUrl: null,
      androidStoreUrl: null,
    });
  }

  setFromHttpError(err: HttpErrorResponse): void {
    const payload = this.extractPayload(err.error);
    const fallbackMessage = 'アプリのアップデートが必要です。アップデートしてください。';
    const message =
      typeof payload.message === 'string' && payload.message.trim().length > 0
        ? payload.message
        : fallbackMessage;

    this._state.set({
      active: true,
      message,
      storeUrl: this.toNullableString(payload.storeUrl),
      iosStoreUrl: this.toNullableString(payload.iosStoreUrl),
      androidStoreUrl: this.toNullableString(payload.androidStoreUrl),
    });
  }

  isForceUpdateError(err: HttpErrorResponse): boolean {
    const payload = this.extractPayload(err.error);

    if (err.status === 426) {
      return true;
    }

    if (payload.force_update === true || payload.forceUpdate === true) {
      return true;
    }

    return payload.code === 'FORCE_UPDATE';
  }

  private extractPayload(error: unknown): ForceUpdatePayload {
    if (!error || typeof error !== 'object') {
      return {};
    }
    return error as ForceUpdatePayload;
  }

  private toNullableString(value: unknown): string | null {
    return typeof value === 'string' && value.trim().length > 0 ? value : null;
  }
}
